/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { useObserver } from "mobx-react-lite";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  useAppInsightsContext,
  useTrackMetric,
} from "@microsoft/applicationinsights-react-js";
import DashboardTabs from "../Dashboard/DashboardTabs";
import MaterialList from "../Materials/MaterialList";
import { AppInsightsConstants } from "../../Constants";
import { useGlobalStore } from "../../state/GlobalStore";
import { AppInsightMethods } from "../../AppInsightMethods";
import { ReactComponent as NoUser } from "../../assets/NoUser.svg";
import RelaxationVideosList from "../RelaxationVideos/RelaxationVideosList";

export const NoResult = () => {
  return (
    <Grid className={"noResultStyle"}>
      <InfoOutlinedIcon />
      <span>No Result</span>
    </Grid>
  );
};
export const NoUsers = () => {
  return (
    <Grid className="noResultStyleNoUser">
      <NoUser />
      <div>Please create your first test user to create test appointment</div>
    </Grid>
  );
};

export default function Resources() {
  const pageName = "Resources";
  const appInsights = useAppInsightsContext();
  const [value, setValue] = useState("Materials");
  const [searchText, setSearchText] = useState("");
  const globalStore = useGlobalStore();
  const trackComponent = useTrackMetric(appInsights, pageName);

  useEffect(() => {
    trackComponent();
  }, []);

  return useObserver(() => {
    return (
      <Grid>
        <DashboardTabs
          parentTabName={pageName}
          selectedSubTab={value}
          handleTabChange={(e: any, newValue: string) => {
            setValue(newValue);
            AppInsightMethods.trackAppInsightsEvent(
              pageName,
              AppInsightsConstants.Information,
              `The "${newValue}" tab has been clicked on the ${pageName} section.`,
              globalStore.loginUserEmail,
              window.location.href,
              ""
            );
          }}
          searchText={searchText}
          setSearchText={(val: string) => setSearchText(val)}
        />
        {value === "Materials" && <MaterialList searchText={searchText} />}
        {value === "Relaxation Video" && (
          <RelaxationVideosList searchText={searchText} />
        )}
      </Grid>
    );
  });
}
